<div class="debugger-panel">
    <h2>Debugger Panel</h2>
    <div *ngFor="let message of messages" class="message">
      <ngx-json-viewer [json]="message" [expanded]="false"></ngx-json-viewer>
    </div>
  </div>
  